import { render, staticRenderFns } from "./ClinicalCaseTabs.vue?vue&type=template&id=205c161e"
import script from "./ClinicalCaseTabs.vue?vue&type=script&lang=js"
export * from "./ClinicalCaseTabs.vue?vue&type=script&lang=js"
import style0 from "./ClinicalCaseTabs.vue?vue&type=style&index=0&id=205c161e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports